import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import { Programa, ProgramaDetails } from './types/types';

export class ProgramaService {
  // POST /programa
  static async create(dto: Programa): Promise<Programa> {
    const response: AxiosResponse<Programa> = await AxiosService.post("/programa", dto);
    return response.data;
  }

  // GET /programa
  static async findAll(): Promise<Programa[]> {
    const response: AxiosResponse<Programa[]> = await AxiosService.get("/programa");
    return response.data;
  }

  // GET /programa/query?date=YYYY-MM-DD
  static async query(date: string): Promise<ProgramaDetails[]> {
    const response: AxiosResponse<ProgramaDetails[]> = await AxiosService.get("/programa/query", {
      params: { date },
    });
    return response.data;
  }

  // GET /programa/:id
  static async findOne(id: string): Promise<Programa> {
    const response: AxiosResponse<Programa> = await AxiosService.get(`/programa/${id}`);
    return response.data;
  }

  static async downloadExcel(id: string, date: string): Promise<void> {
    const response = await AxiosService.get(`/programa/${id}/excel`, {
      responseType: "blob", // 👈 importante para recibir binario
    });

    const blob = new Blob([response.data as BlobPart], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `programa-${date}-${id}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
  
}